<div class="carDetails">
    <div class="container">
        <div class="row">
            
            <div class="col-md-8">
                <div class="carDetailsLeft">
                    <h5>{{dealerData?.DealerName}} <span>verified</span> </h5>
                    <div class="profileMeta">
                        <ul>
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-patch-check" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M10.354 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>
                                    <path d="m10.273 2.513-.921-.944.715-.698.622.637.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636a2.89 2.89 0 0 1 4.134 0l-.715.698a1.89 1.89 0 0 0-2.704 0l-.92.944-1.32-.016a1.89 1.89 0 0 0-1.911 1.912l.016 1.318-.944.921a1.89 1.89 0 0 0 0 2.704l.944.92-.016 1.32a1.89 1.89 0 0 0 1.912 1.911l1.318-.016.921.944a1.89 1.89 0 0 0 2.704 0l.92-.944 1.32.016a1.89 1.89 0 0 0 1.911-1.912l-.016-1.318.944-.921a1.89 1.89 0 0 0 0-2.704l-.944-.92.016-1.32a1.89 1.89 0 0 0-1.912-1.911l-1.318.016z"/>
                                </svg>

                                <div>
                                    <p>Ratings:</p>
                                    <span class="rating">
                                        <i class="fa-solid fa-star" [ngClass]="{'filled':dealerData?.Rating >= 1}"></i>
                                        <i class="fa-solid fa-star filled" [ngClass]="{'filled':dealerData?.Rating >= 2}"></i>
                                        <i class="fa-solid fa-star filled" [ngClass]="{'filled':dealerData?.Rating >= 3}"></i>
                                        <i class="fa-solid fa-star" [ngClass]="{'filled':dealerData?.Rating >= 4}"></i>
                                        <i class="fa-solid fa-star" [ngClass]="{'filled':dealerData?.Rating >= 5}"></i>
                                    </span>
                                </div>
                            </li>

                              <!-- <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar2-week" viewBox="0 0 16 16">
                                    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H2z"/>
                                    <path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V4zM11 7.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm-5 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1z"/>
                                  </svg>

                                <div>
                                    <p>Member since:</p>
                                    <small>June 30, 2017</small>
                                </div>
                            </li> -->

                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clock" viewBox="0 0 16 16">
                                    <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/>
                                </svg>

                                <div>
                                    <p>Working Hours:</p>
                                    <small>{{dealerData?.WorkHours}}</small>
                                </div>
                            </li>
                        </ul>
                    </div>

                        <mdb-carousel class="carousel slide carousel-fade">
                          <mdb-carousel-item *ngFor="let item of media">
                            <img *ngIf="item.MediaType == 'I' && item.MediaURL" [src]="item.MediaURL"
                              class="d-block w-100 rounded" alt="image" (error)="item.MediaURL = null" />
                            <video *ngIf="item.MediaType != 'I' && item.MediaURL" class="d-block w-100 rounded" controls
                              (error)="item.MediaURL = null">
                              >
                              <source [src]="item.MediaURL" type="video/mp4" (error)="item.MediaURL = null" />
                              Your browser does not support the video tag.
                            </video>
                            <h4 *ngIf="!item.MediaURL">
                              <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/not-found.png" />
                            </h4>
                          </mdb-carousel-item>
                        </mdb-carousel>
                    <div class="detailAbout">
                        <h4>About:</h4>
                        <p>{{dealerData?.ShortIntro}}</p>
                    </div>

                    <div class="inventory">
                        <h5 class="title">Inventory:</h5>
                        <ul>
                            <li class="inventoryListing" *ngFor="let list of dealerListingData">
                                <div class="row" >
                                    <div class="col-md-3 p-0">
                                        <!-- <img [src]="getImage(list)" class="img-fluid" alt=""> -->
                                        <mdb-carousel class="carousel slide carousel-fade">
                                            <mdb-carousel-item *ngFor="let item of getImages(list)">
                                              <img *ngIf="item.MediaType == 'I' && item.MediaURL" [src]="item.MediaURL"
                                                class="d-block w-100 rounded" alt="image" (error)="item.MediaURL = null" />
                                              <video *ngIf="item.MediaType != 'I' && item.MediaURL" class="d-block w-100 rounded" controls
                                                (error)="item.MediaURL = null">
                                                >
                                                <source [src]="item.MediaURL" type="video/mp4" (error)="item.MediaURL = null" />
                                                Your browser does not support the video tag.
                                              </video>
                                              <h4 *ngIf="!item.MediaURL">
                                                <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/not-found.png" />
                                              </h4>
                                            </mdb-carousel-item>
                                          </mdb-carousel>
                                    </div>
                                    <div class="col-md-9" (click)="navigate(list?.ListingHandle)">
                                        <div class="row">
                                            <div class="col-md-10 col-8">
                                                <span class="used">{{list.Condition}}</span>
                                                <h5 style="cursor: pointer">{{list.ListingHeader}}</h5>

                                                <ul class="location">
                                                    <li>
                                                        <i class="fa-solid fa-location-dot"></i>
                                                        {{list.Location}}
                                                    </li>
                                                    <li>
                                                        <i class="fa-solid fa-clock"></i>
                                                        {{list.MakeMonth}} {{list.MakeYear}}
                                                    </li>
                                                </ul>

                                                <ul class="detail">
                                                    <li>Petrol</li>
                                                    <li>1,694 km</li>
                                                    <li>3,000 cc</li>
                                                    <li>Sedan</li>
                                                    <li>{{list.Color}}</li>
                                                </ul>
                                            </div>

                                            <div class="col-md-2 col-4 p-0">
                                                <div class="pricing">
                                                    <div class="d-flex justify-content-end  pt-1 mb-3"><span class="currency">{{dealerData?.PrimaryCurrencyText}}</span><span class="askingPrice">{{list.AskingPrice}}</span></div>
                                                    <small>(Negotiable)</small>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </li>

                           </ul>

                        <div class="moreBtn">
                            <a>
                                <button class="btn" type="button" (click)="getMore()"> More Ads {{fullDealerListingData.length}}</button>
                            </a>
                        </div>
                    </div>

                    <div class="review">
                        <h5>Reviews:</h5>
                        <div class="reviewWrap">
                            <div class="left">
                                <h2>3.3</h2>
                                <i class="fa fa-star filled"></i>
                                <i class="fa fa-star filled"></i>
                                <i class="fa fa-star filled"></i>
                                <i class="fa fa-star"></i>
                                <i class="fa fa-star"></i>
                            </div>
                            <div class="right">

                                <h5 class="name">demo</h5>
                                <span class="designation">demo</span>

                                <p>has Recommended this vendor on January 15, 2021</p>

                                <div class="row">
                                    <div class="col-md-4">
                                        <h5>Level of Services</h5>
                                        <div class="rating">
                                            <i class="fa fa-star filled"></i>
                                            <i class="fa fa-star filled"></i>
                                            <i class="fa fa-star filled"></i>
                                            <i class="fa fa-star"></i>
                                            <i class="fa fa-star"></i>
                                        </div>
                                    </div>

                                    <div class="col-md-4">
                                        <h5>Buying Process</h5>
                                        <div class="rating">
                                            <i class="fa fa-star filled"></i>
                                            <i class="fa fa-star filled"></i>
                                            <i class="fa fa-star filled"></i>
                                            <i class="fa fa-star"></i>
                                            <i class="fa fa-star"></i>
                                        </div>
                                    </div>

                                    <div class="col-md-4">
                                        <h5>Vehicle Selection</h5>
                                        <div class="rating">
                                            <i class="fa fa-star filled"></i>
                                            <i class="fa fa-star filled"></i>
                                            <i class="fa fa-star filled"></i>
                                            <i class="fa fa-star"></i>
                                            <i class="fa fa-star"></i>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="allReview">
                            <a>
                                <button class="btn" type="button">Read All Reviews</button>
                            </a> 
                        </div>

                        <div class="loginToReview">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                            </svg>

                            <div>
                                <h5>Login To Write A Review.</h5>
                                <p>Sorry, only login users are eligibale to post a review..</p>
                            </div>
                        </div>

                    </div>

                </div>
                
            </div>

            <div class="col-md-4">
                <div class="detailCard">
                    <img [src]="dealerData?.LogoURL" class="img-fluid" alt="">

                    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">

                        <li class="nav-item" role="presentation">
                          <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">DETAIL</button>
                        </li>
                        
                        <li class="nav-item" role="presentation">
                          <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">CONTACT</button>
                        </li>
                     
                      </ul>
                      <div class="tab-content" id="pills-tabContent">

                        <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab" tabindex="0">
                            <ul>
                                <li>
                                    <i class="fa-solid fa-location-dot"></i>
                                    <div>
                                        <h5>Address</h5>
                                        <p>{{dealerData?.UnitNo}} {{dealerData?.FloorAndTower}} {{dealerData?.BuildingOrSociety}} {{dealerData?.LocalityName}} {{dealerData?.Landmark}}</p>
                                    </div>
                                </li>

                                <li>
                                    <i class="fa-solid fa-mobile-screen"></i>
                                    <div>
                                        <h5>	
                                            Contact Number</h5>
                                        <p>{{dealerData?.MobileNumber}}</p>
                                    </div>
                                </li>

                                <li>
                                    <i class="fa-solid fa-earth-africa"></i>
                                    <div>
                                        <h5> Website</h5>
                                        <p>{{dealerData?.Website}}</p>
                                    </div>
                                </li>
                            </ul>
                        </div>

                        <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab" tabindex="0">

                            <form>
                                <div class="mb-3">
                                  <input type="text" class="form-control" placeholder="Full Name">
                                </div>

                                <div class="mb-3">
                                    <input type="text" class="form-control" placeholder="Email Address">
                                </div>

                                <div class="mb-3">
                                    <input type="text" class="form-control" placeholder="Phone No">
                                </div>

                                <div class="mb-3">
                                     <textarea class="form-control" placeholder="Your Message" rows="3"></textarea>
                                </div>
                                
                                <button type="submit" class="btn">send Message</button>
                              </form>

                        </div>
                       
                      </div>
                </div>

                <div class="mt-4" *ngIf="dealerData && dealerData.Latitude && dealerData.Longitude">
                    <!-- <iframe [src]="mapUrl" width="100%" height="300" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> -->
                    <agm-map
                    [latitude]="GetFloat(dealerData.Latitude)"
                    [longitude]="GetFloat(dealerData.Longitude)"
                    [zoom]="16"
                    [maxZoom]="20"
                  >
                    <agm-marker
                      [latitude]="GetFloat(dealerData.Latitude)"
                      [longitude]="GetFloat(dealerData.Longitude)"
                      (mouseOver)="onMouseOver(infoWindow, $event)"
                      (mouseOut)="onMouseOut(infoWindow, $event)"
                    >
                      <agm-info-window [disableAutoPan]="false" #infoWindow>
                        <div class="cBranchName">
                          <i class="fa fa-building" aria-hidden="true"></i>
                          <span class="cBranchNameItem">{{
                            dealerData.DealerName
                          }}</span>
                        </div>
                        <div class="cBranchAddress">
                          <i
                            class="fa fa-location-arrow"
                            aria-hidden="true"
                          ></i>
                          <span class="cBranchAddressItem">{{
                            dealerData.LocalityName
                          }}</span>
                        </div>
                        <div class="cBranchPhone">
                          <i class="fa fa-phone" aria-hidden="true"></i>
                          <span class="cBranchPhoneItem">{{
                            dealerData.MobileNumber
                          }}</span>
                        </div>
                      </agm-info-window>
                    </agm-marker>
                  </agm-map>
                    <!-- <agm-map
                    [latitude]="dealerData?.latitude"
                    [longitude]="dealerData?.longitude"
                    [zoom]="16"
                    [maxZoom]="20"
                  >
                    <agm-marker
                      [latitude]="dealerData?.latitude"
                      [longitude]="dealerData?.longitude"
                   
                    >
                    
                    </agm-marker>
                  </agm-map> -->
                </div>

                <div class="bigBanner mt-4">
                    <img src="./img/big.png" class="img-fluid" alt="">
                </div>
                
            </div>
        </div>

    </div>
    
</div>